import { forwardRef } from "react"

const Textarea = forwardRef(function Textarea({klass, error, ...props}, ref) {
  let thisKlass = "border sm:text-sm rounded-lg block w-full p-2"
  if (!error || error === "") {
    thisKlass = thisKlass + " bg-gray-50 border-gray-300 text-gray-900 focus:ring-primary-600 focus:border-primary-600"
  } else {
    thisKlass = thisKlass + " bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500"
  }

  if (klass !== null) {
    thisKlass = thisKlass + " " + klass
  }

  return (
    <>
      <textarea
        ref={ref}
        className={thisKlass}
        {...props}
      />
      {error && error !== "" && <p className={"mt-2 text-sm text-red-600"}>{error}</p>}
    </>
  )
})

export default Textarea;
